"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveAppDetailViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveAppDetailViewModel = function () {
        function FourFiveAppDetailViewModel(fourFiveAppDetail) {
            _classCallCheck(this, FourFiveAppDetailViewModel);

            this.id = ko.observable('');
            this.created = ko.observable('');
            this.firstLoginDate = ko.observable('');
            this.lastLoginDate = ko.observable('');
            this.passCodeCount = ko.observable(0);
            this.lastPassCodeDate = ko.observable('');
            this.apiVersion = ko.observable('');
            this.build = ko.observable('');
            this.deviceType = ko.observable('');
            this.deviceName = ko.observable('');
            this.deviceVersion = ko.observable('');
            this.idiom = ko.observable('');
            this.manufacturer = ko.observable('');
            this.model = ko.observable('');
            this.package = ko.observable('');
            this.platform = ko.observable('');
            this.version = ko.observable('');
            this.status = ko.observable('');
            this.update(fourFiveAppDetail);
        }

        _createClass(FourFiveAppDetailViewModel, [{
            key: "update",
            value: function update(fourFiveAppDetail) {
                this.id(fourFiveAppDetail.id);
                this.created(moment(fourFiveAppDetail.created).format('DD/MM/YYYY HH:mm:ss'));
                this.firstLoginDate(fourFiveAppDetail.firstLoginDate ? moment(fourFiveAppDetail.firstLoginDate).format('DD/MM/YYYY HH:mm:ss') : '');
                this.lastLoginDate(fourFiveAppDetail.lastLoginDate ? moment(fourFiveAppDetail.lastLoginDate).format('DD/MM/YYYY HH:mm:ss') : '');
                this.passCodeCount(fourFiveAppDetail.passCodeCount);
                this.lastPassCodeDate(fourFiveAppDetail.lastPassCodeDate ? moment(fourFiveAppDetail.lastPassCodeDate).format('DD/MM/YYYY HH:mm:ss') : '');
                this.apiVersion(fourFiveAppDetail.apiVersion);
                this.build(fourFiveAppDetail.build);
                this.deviceType(fourFiveAppDetail.deviceType);
                this.deviceName(fourFiveAppDetail.deviceName);
                this.deviceVersion(fourFiveAppDetail.deviceVersion);
                this.idiom(fourFiveAppDetail.idiom);
                this.manufacturer(fourFiveAppDetail.manufacturer);
                this.model(fourFiveAppDetail.model);
                this.package(fourFiveAppDetail.package);
                this.platform(fourFiveAppDetail.platform);
                this.version(fourFiveAppDetail.version);
                this.status(fourFiveAppDetail.status);
            }
        }, {
            key: "clear",
            value: function clear() {
                this.id('');
                this.created('');
                this.firstLoginDate('');
                this.lastLoginDate('');
                this.passCodeCount(0);
                this.lastPassCodeDate('');
                this.apiVersion('');
                this.build('');
                this.deviceType('');
                this.deviceName('');
                this.deviceVersion('');
                this.idiom('');
                this.manufacturer('');
                this.model('');
                this.package('');
                this.platform('');
                this.version('');
                this.status('');
            }
        }]);

        return FourFiveAppDetailViewModel;
    }();

    return FourFiveAppDetailViewModel;
});
//# sourceMappingURL=fourFiveAppDetailViewModel.js.map;
